/**
 * Какие плитки периодических отчётов (замеры раз в неделю, фото раз в 30 дней)
 * показывать в шкале «Отчёты» Дневника.
 *
 * Клубу шкала их не показывает вовсе. #610: фото — только если они есть в
 * тарифе (матрица, функция `photos`): у Программы фото нет, сервер их не
 * принимает, а плитка «Фото» всё равно предлагала сдать отчёт и вела в
 * шторку «Сдать фото в Telegram».
 */
export function periodicReportTiles(isClub: boolean, photosInTariff: boolean): { meas: boolean; photo: boolean } {
  return { meas: !isClub, photo: !isClub && photosInTariff }
}
